// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"16ec74ce","337":"8adc1399","455":"851bd7d7"}[chunkId] + ".chunk.js";
};